// extracted by mini-css-extract-plugin
module.exports = {"page":"Layout-module__page___Y1tS2","main":"Layout-module__main___ML7s0","inner":"Layout-module__inner___2iLWQ"};